import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

interface NavigationData {
  title: string;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  navigaionData$: BehaviorSubject<NavigationData | null> = new BehaviorSubject<NavigationData | null>(null)

  get navigaionData(): NavigationData | null {
    return this.navigaionData$.value;
  }

  set navigaionData(value: NavigationData) {
    this.navigaionData$.next(value);
  }

  constructor() { }
}
